export enum TransactionTypeEnum {
  TangibleGoods = 1,
  IntangibleGoods,
  Services,
  Loans,
}
